
import { CircularProgress } from '@mui/material';
import { IMetadataTab } from 'models/metadata';
import MetadataTabs from './MetadataTabs';
import { useEffect, useState } from 'react';
import MetadataPanel from './MetadataPanel';
import MetadataContainer from './MetadataContainer';
import MetadataNotFound from './MetadataNotFound';
import { useBootstrap, useFormio } from 'hooks/shared';
import './Metadata.css';

import { OnGetMetadataSignature, OnSetMetadataSignature } from './MetadataEventTypes';

type MetadataProps = {
    loading: boolean;
    loadingValues: boolean;
    tabs: IMetadataTab[] | null;
    refreshKey?: number;
    checkAlert: (group: IMetadataTab) => boolean;
    onLoadValues: OnGetMetadataSignature;
    onUpdateValue: OnSetMetadataSignature;
};

const Metadata: React.FC<MetadataProps> = (props) => {
    const {
        loading,
        loadingValues,
        tabs,
        refreshKey,
        checkAlert,
        onLoadValues,
        onUpdateValue
    } = props;
    
    useBootstrap();
    useFormio();

    const [ selectedTab, setSelectedTab ] = useState('');
    const [localLoading, setLocalLoading] = useState(false);
    const [activeTab, setActiveTab] = useState<IMetadataTab | null>(null);

    useEffect(() => {
        setLocalLoading(true);
        setActiveTab(
            selectedTab !== ''
                ? tabs?.find(t => t.key === selectedTab) ?? null
                : null);
    }, [tabs, selectedTab]);

    useEffect(() => {
        if (localLoading) {
            setLocalLoading(false);
            return;
        }
    }, [localLoading]);

    useEffect(() => {
        console.log('set default tab');
        if (selectedTab === '' && tabs && tabs.length > 0) {
            setSelectedTab(tabs[0].key);
        }
    }, [ tabs ]);

    if (loading) {
        return (
            <MetadataContainer>
                <CircularProgress />
            </MetadataContainer>
        );
    }

    if (tabs === null || tabs.length === 0) {
        return (
            <MetadataNotFound />
        );
    }

    return (
        <MetadataContainer>
            <MetadataTabs
                key={refreshKey}
                tabs={tabs} 
                selectedValue={selectedTab} 
                setSelectedValue={setSelectedTab}
                checkAlert={checkAlert}
            />
            {localLoading && <CircularProgress />}
            {!localLoading && activeTab &&
                <MetadataPanel
                    loading={loadingValues}
                    activeTab={activeTab}
                    onLoadValues={onLoadValues}
                    onUpdateValue={onUpdateValue}
                />
            }
        </MetadataContainer>
    );
};

export default Metadata;